import React from 'react';
import classes from './BackDrop.css';

const BackDrop=(props)=>{
	return (props.show)?<div className={classes.Backdrop} onClick={props.click}></div>:null;
}

export default BackDrop;


// WEBPACK FOOTER //
// ./src/components/UI/backdrop/Backdrop.jsx